import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-container">
                <Link to="/impressum" className="footer-link">Impressum</Link>
                <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
            </div>
        </footer>
    );
};

export default Footer;